import { ClienteDTO, CodigoValorDTO } from "@DTOS";

export namespace CodigosAcciones {
    export class CargarClientes {
        static readonly type = "[Codigos] Cargar clientes";
        constructor(public clientes: ClienteDTO[]) {}
    }

    export class ObtenerCodigos {
        static readonly type = "[Codigos] Obtener";
    }

    export class AgregarCodigo {
        static readonly type = "[Codigos] Agregar";
        constructor(public codigoValor: CodigoValorDTO, public cliente) {}
    }
}
